angular.module( 'acme.view.application.roles.permissions', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.roles.permissions.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var rolesPermissions = {
        name: 'application.roles.permissions',
        url: '/:id/permissions',
        views: {
          "subview-main": {
            controller: 'RolesPermissionsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/roles/permissions/permissions.tpl.html'
          }
        },
        data: {
          pageTitle: 'Role Permissions',
          permissions: ['ROLES_UPDATE']
        },
        resolve: {
          RoleData: [ '$stateParams', 'ApiService', function($stateParams, ApiService) {
            return ApiService.roles.detail($stateParams.id);
          }]
        }
      };

    $stateProvider
      .state(rolesPermissions);
});
